import { render, staticRenderFns } from "./ChapterPractice.vue?vue&type=template&id=28798dd0&scoped=true&"
import script from "./ChapterPractice.vue?vue&type=script&lang=js&"
export * from "./ChapterPractice.vue?vue&type=script&lang=js&"
import style0 from "./ChapterPractice.vue?vue&type=style&index=0&id=28798dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28798dd0",
  null
  
)

export default component.exports